<script setup lang="ts">
const props = defineProps({
  searchId: null
})
const { state: agentState } = useAgent()

const search = computed(() => agentState.value.searchReferences[props.searchId])
</script>

<template>
  <search-item
    v-if="search"
    location="agent"
    :search
  />
  <div v-else>
    Loading...
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'
</style>
